import { Injectable } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import {BillPaymentPrescriptionUpdateDialogComponent } from "src/app/components/bill-payment-prescription-update-dialog/bill-payment-prescription-update-dialog.component";
import { BillPay_ItemType, tBillPayModel } from "src/app/models/tBillPayModel";
import { LoggerService } from "./logger.service";

var TAG = "BillPayPrescriptionUpdateDialogService";

@Injectable({
    providedIn: 'root'
})
export class BillPayPrescriptionUpdateDialogService {

    constructor(private log: LoggerService,
        private modalService: NgbModal,
        private translate: TranslateService,

    ) { }

    openDialog(msg: string,dataList_item: tBillPayModel[],invoiceID:string) {
         console.log('open Dialog invoiceID = '+invoiceID);
        const modalRef = this.modalService.open(BillPaymentPrescriptionUpdateDialogComponent, { centered: true, backdrop: 'static',size: 'lg'});

            var billPayPrescriptionList: tBillPayModel[] = new Array;
            for (var i = 0; i < dataList_item.length; i++) {

                var itemType = dataList_item[i].bpItemType;
                if ( itemType == BillPay_ItemType.PRESCRIPTION) {
                  billPayPrescriptionList.push(dataList_item[i]);
                }
            }

        modalRef.componentInstance.msg = msg;
        modalRef.componentInstance.billPayPrescriptionList = billPayPrescriptionList;
        modalRef.componentInstance.invoiceID = invoiceID;

        return modalRef;

    }



}
